import React, {useState, useEffect} from 'react';

import "./PDSAOverview.css";
import changeIdeaIcon from "../../../../../resources/images/change-idea-icon.png";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import {deletePDSA, viewPDSAsForChangeIdea} from "../../../../../services/PDSAService";
import {OverviewListItem} from "../../../../common/list/overview-list-item/OverviewListItem";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {ConfirmDeleteModal} from "../../../../common/confirmation-modal/ConfimDeleteModal";

export const PDSAOverview = ({context, setContext, navigateTo, setSpinnerText, showToaster, toolTipsEnabled}) => {

    const [PDSAList, setPDSAList] = useState();
    const [showModal, setShowModal] = useState(false);
    const [extRefToBeDeleted, setExtRefToBeDeleted] = useState(null);
    const [modalTitle, setModalTitle] = useState(null);

    useEffect(() => {
        if (!context.viewMode) {
            setContext((prevState) => ({
                ...prevState,
                breadcrumbs: {
                    ...prevState.breadcrumbs,
                    PDSABreadCrumb: {
                        text: "Overview",
                        type: "PDSA",
                        screenKey: "PDSAOverview",
                    }
                },
            }));
        }

        const fetchData = async () => {
            setSpinnerText("Retrieving PDSAs");
            await retrievePDSAs();
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    const retrievePDSAs = async () => {
        const [data, error] = await viewPDSAsForChangeIdea(context.username, context.changeIdeaScreen.externalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                const mappedPDSAList = data.pdsaVOs.map((PDSA) => {
                    if (!PDSA.status) {
                        PDSA.status = "In Progress"
                    }

                    return {
                        externalReference: PDSA.externalReference,
                        processMeasureList: PDSA.processMeasures,
                        name: PDSA.name,
                        who: PDSA.who,
                        what: PDSA.what,
                        where: PDSA.where,
                        testStartDate: PDSA.testStartDate,
                        testReviewDate: PDSA.testReviewDate,
                        scale: PDSA.scale,
                        observation: PDSA.observations,
                        balancingMeasureOne: PDSA.balanceMeasureA,
                        balancingMeasureTwo: PDSA.balanceMeasureB,
                        balancingMeasureThree: PDSA.balanceMeasureC,
                        analysis: PDSA.analysis,
                        status: {value: PDSA.status, label: PDSA.status,},
                        statusMovement: PDSA.statusMovement,
                        rationale: PDSA.rationale,
                        nextVisitDate: PDSA.dateOfNextVisit,
                        isActiveVersion: PDSA.isActiveVersion,
                        reviewDate: PDSA.reviewDate,
                    }
                });
                setPDSAList(mappedPDSAList);
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
    }

    const handleAddPDSAClick = () => {
        setContext((prevState) => ({
            ...prevState,
            PDSAScreen: null,
        }));
        navigateTo("PDSACycle")
    }

    const handleViewListItemClick = (PDSA) => {
        setContext((prevState) => ({
            ...prevState,
            copyOfPDSAScreen: null,
            PDSAScreen: {...PDSA}
        }));
        navigateTo("PDSACycle");
    }

    const handleDeleteListItemClick = async (externalReference) => {
        setSpinnerText("Deleting PDSA");
        let PDSADeleted = false;
        const [data, error] = await deletePDSA(context.username, externalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                PDSADeleted = true;
            }
            showToaster(data);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }

        if (PDSADeleted) {
            await retrievePDSAs();
            setShowModal(false);
        }
        setSpinnerText(null);
    }

    const buildPDSAList = () => {
        if (PDSAList) {
            return PDSAList.map((PDSA, index) => {
                const deleteDisabled = !PDSA.isActiveVersion || !context.editMode || PDSA.status.label === "Adopt" || PDSA.status.label === "Abandon";

                return (
                    <OverviewListItem key={index}
                                      text={PDSA.name + " - " + PDSA.statusMovement}
                                      disableDelete={deleteDisabled}
                                      onViewClick={() => {
                                          handleViewListItemClick(PDSA);
                                      }}
                                      onDeleteClick={() => {
                                          handleDeleteModalShow(PDSA.externalReference, PDSA.name);
                                      }}/>
                );
            });
        }
    }

    const handleDeleteModalShow = async (extRef, title) => {
        setShowModal(true);
        setExtRefToBeDeleted(extRef);
        setModalTitle(title);
    }

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={changeIdeaIcon} alt="Change Idea Icon" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.changeIdeaScreen.title}</p>
                </div>
                <div className="wizard-right-container">
                    <div className="pdsa-overview-list-container">
                        <div className={"label-div-tooltip-h2"}>
                            <label className={"label-h2"}>PDSA Overview</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"PDSAoverview123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"PDSA Overview:"}/>}
                        </div>
                        {buildPDSAList()}
                        <StandardButton text="Add PDSA" onClick={handleAddPDSAClick} disabled={!context.editMode}/>
                    </div>
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="pdsa-overview-button-container">
                        <StandardButton text="Change Idea Overview" onClick={() => {
                            navigateTo("changeIdeaOverview");
                        }}/>
                    </div>
                </div>
            </div>
            {showModal &&
            <ConfirmDeleteModal showModal={showModal}
                                setShowModal={setShowModal}
                                titleToDelete={modalTitle}
                                onDeleteClick={() => {
                                    handleDeleteListItemClick(extRefToBeDeleted)
                                }}/>}
            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>
        </div>
    );
}
